/** Explicit low-understory opt-in, independent of background-only upgrades.
 * Shared declarations only: no renderer, atmosphere builders or map mutation. */
export const TREE_FREE_SCENERY_BIOMES = {
  crystal_caverns: 'cave',
  ancient_temple: 'dungeon',
  sunken_ruins: 'underwater',
  frozen_lake: 'arctic',
  volcano_summit: 'volcanic',
  stormbreak_cliffs: 'tempest',
  sunless_deep: 'abyss',
  frostspire_peaks: 'frostspire',
  skyreach_isles: 'skylands',
} as const;

/** Background-only admission never opts a map into vegetation changes. */
export const CONNECTED_SCENERY_BIOMES = {
  ...TREE_FREE_SCENERY_BIOMES,
  dark_forest: 'forest_road',
  scorched_dunes: 'desert',
  amber_grove: 'autumn',
  sakura_vale: 'sakura',
  smoldering_wastes: 'ashlands',
  stoneveil_barrens: 'petrified',
} as const;

export type ConnectedSceneryMap = keyof typeof CONNECTED_SCENERY_BIOMES;
type TreeFreeSceneryMap = keyof typeof TREE_FREE_SCENERY_BIOMES;

export function isConnectedSceneryMap(value: string | undefined): value is ConnectedSceneryMap {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(CONNECTED_SCENERY_BIOMES, value);
}

export function isTreeFreeSceneryMap(value: string | undefined): value is TreeFreeSceneryMap {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(TREE_FREE_SCENERY_BIOMES, value);
}
